import React from 'react';
import { Alert, Collapse, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ErrorBanner({ message, onClose }){
  const [open, setOpen] = React.useState(Boolean(message));
  React.useEffect(()=> setOpen(Boolean(message)), [message]);
  if (!message) return null;
  return (
    <Collapse in={open}>
      <Alert severity="error" sx={{ mb:2 }}
             action={<IconButton color="inherit" size="small" aria-label="close" onClick={()=>{ setOpen(false); onClose && onClose(); }}><CloseIcon fontSize="small" /></IconButton>}>
        {message}
      </Alert>
    </Collapse>
  );
}

